var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("businessDocuments.form_document_send_title"),
        icon: "icon-sent",
        returnUrl: "/home/",
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          !_vm.isSmartphoneOS
            ? _c(
                "div",
                [
                  _c(
                    "form-accordion",
                    { attrs: { title: _vm.$t("attachments.file") } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c(
                                "form-write-group-label-input",
                                {
                                  attrs: {
                                    isMandatory: "",
                                    inputLabel: _vm.$t(
                                      "businessDocuments.document_type"
                                    ),
                                    inputType: "listeSelect",
                                    mandatoryErrorIndicator:
                                      _vm.fileTypeSelectedError,
                                  },
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.fileTypeSelected,
                                          expression: "fileTypeSelected",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { id: "sel2", readonly: "" },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.fileTypeSelected = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          _vm.setSerialize,
                                        ],
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "businessDocuments.slct_doct_type"
                                            )
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.fileTypeList,
                                        function (fileType) {
                                          return _c(
                                            "option",
                                            {
                                              key: fileType.fileTypeValue,
                                              style: fileType.disabled
                                                ? "font-style:italic;"
                                                : "",
                                              attrs: {
                                                disabled: fileType.disabled,
                                              },
                                              domProps: {
                                                value: fileType.fileTypeValue,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      fileType.fileTypeLabel
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t(
                                    "businessDocuments.request_name_send_doc"
                                  ),
                                  placeholderValue: _vm.$t(
                                    "businessDocuments.request_name_send_doc_placeholder"
                                  ),
                                  mandatoryErrorIndicator: _vm.requestNameError,
                                },
                                model: {
                                  value: _vm.requestName,
                                  callback: function ($$v) {
                                    _vm.requestName = $$v
                                  },
                                  expression: "requestName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  inputLabel: _vm.$t("common.rfrnc"),
                                  placeholderValue: _vm.$t("common.rfrnc_desc"),
                                },
                                model: {
                                  value: _vm.fileReference,
                                  callback: function ($$v) {
                                    _vm.fileReference = $$v
                                  },
                                  expression: "fileReference",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  inputType: "date",
                                  inputLabel: _vm.$t(
                                    "businessDocuments.creation_date"
                                  ),
                                  placeholderValue: _vm.$t("common.slct_date"),
                                },
                                model: {
                                  value: _vm.creationDate,
                                  callback: function ($$v) {
                                    _vm.creationDate = $$v
                                  },
                                  expression: "creationDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "form-accordion",
                    {
                      attrs: {
                        title: _vm.$t("businessDocuments.file_location"),
                        star: true,
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group",
                              attrs: { sm: "12", lg: "6" },
                            },
                            [
                              _vm.locationTypeFile === "1"
                                ? _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { staticClass: "form-group" },
                                        [
                                          _c(
                                            "f7-button",
                                            {
                                              staticClass:
                                                "invoiceButton buttonAccordionForm generalBottomButton",
                                              attrs: { round: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showFileSelectionWindow(
                                                    _vm.locationTypeFile
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "attachments.import_file_singular"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c("b-col", { staticClass: "form-group" }, [
                                    _vm.locationTypeFile === "2"
                                      ? _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.fileId,
                                                expression: "fileId",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { id: "sel2", readonly: "" },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.fileId = $event.target
                                                    .multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                },
                                                function ($event) {
                                                  return _vm.loadCloudFile()
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "",
                                                  default: "",
                                                  disabled: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      this.hasCloudAttachments
                                                        ? _vm.$t(
                                                            "creation_forms.slct_a_fl"
                                                          )
                                                        : _vm.$t(
                                                            "attachments.no_document"
                                                          )
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.cloudDocs,
                                              function (cloudDoc) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: cloudDoc.id,
                                                    domProps: {
                                                      value: cloudDoc.id,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(cloudDoc.name) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("input", {
                                      ref: "fileButton",
                                      staticClass:
                                        "item-input hiddenElementAllSize local-file-input",
                                      attrs: { type: "file" },
                                      on: { change: _vm.executeOCR },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass: "hiddenElementAllSize",
                                      attrs: { type: "text" },
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      staticClass: "hiddenElementAllSize",
                                      attrs: {
                                        type: "text",
                                        id: "recommendation-list-input",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.fileArrayError
                                      ? _c(
                                          "div",
                                          { staticStyle: { color: "red" } },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "errors.is_mandatory",
                                                    {
                                                      mandatoryValue: _vm.$t(
                                                        "attachments.import_file_singular"
                                                      ),
                                                    }
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          this.fileNameArray.length != 0
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "form-group",
                                  attrs: { sm: "12", lg: "6" },
                                },
                                [
                                  _c(
                                    "table",
                                    {
                                      staticClass:
                                        "table table-striped table-bordered",
                                      staticStyle: { "table-layout": "fixed" },
                                    },
                                    [
                                      _c("thead", [
                                        _c("tr", [
                                          _c(
                                            "th",
                                            {
                                              staticStyle: { width: "70%" },
                                              attrs: { scope: "col" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "businessDocuments.document_lst"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "th",
                                            { attrs: { scope: "col" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("common.action_label")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "tbody",
                                        _vm._l(
                                          this.fileNameArray,
                                          function (filename) {
                                            return _c("tr", [
                                              _c(
                                                "td",
                                                { staticClass: "textOverflow" },
                                                [_vm._v(_vm._s(filename))]
                                              ),
                                              _vm._v(" "),
                                              _c("td", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.removeFile(
                                                          filename
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "i",
                                                      {
                                                        staticClass:
                                                          "icon button-delete f7-icons",
                                                      },
                                                      [_vm._v("close")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "labelDelete",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.rm_label"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ])
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isSmartphoneOS
            ? _c(
                "div",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "f7-button",
                            {
                              staticClass: "button-action-main greenButton",
                              attrs: {
                                title: _vm.$t("creation_forms.tke_doct_pctr"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.scanDocument($event)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("creation_forms.tke_doct_pctr"))
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-row", [
                    _c("span", { staticClass: "labelSub greyLabel" }, [
                      _vm._v(_vm._s(_vm.$t("common.or_label_maj"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "f7-button",
                            {
                              staticClass: "button-action-sub greyButton",
                              attrs: {
                                title: _vm.$t(
                                  "businessDocuments.local_location_small"
                                ),
                                disabled: _vm.$engine.rights.rightIs(
                                  "attachment_consulter",
                                  false
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showFileSelectionWindow("1")
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "businessDocuments.local_location_small"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "f7-button",
                            {
                              staticClass: "button-action-sub greyButton",
                              attrs: {
                                title: _vm.$t(
                                  "businessDocuments.moneyroad_location_small"
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.filesPicker($event)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "businessDocuments.moneyroad_location_small"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      this.locationTypeFile != "0" && false
                        ? _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("label", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("businessDocuments.document_name")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.fileNameLabel,
                                    expression: "fileNameLabel",
                                  },
                                ],
                                staticClass: "form-control inputAccordionForm",
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t(
                                    "creation_forms.slct_a_fl"
                                  ),
                                  readonly: "",
                                  id: "application-file-input-mobile",
                                },
                                domProps: { value: _vm.fileNameLabel },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.fileNameLabel = $event.target.value
                                  },
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      this.fileNameArray.length != 0
                        ? _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "12" } },
                            [
                              _c("i", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("businessDocuments.othr_pages_label")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-striped table-bordered",
                                  staticStyle: { "table-layout": "fixed" },
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticStyle: { width: "70%" },
                                          attrs: { scope: "col" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "businessDocuments.document_lst"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("th", { attrs: { scope: "col" } }, [
                                        _vm._v(
                                          _vm._s(_vm.$t("common.action_label"))
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      this.fileNameArray,
                                      function (filename) {
                                        return _c("tr", [
                                          _c(
                                            "td",
                                            { staticClass: "textOverflow" },
                                            [_vm._v(_vm._s(filename))]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "a",
                                              {
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeFile(
                                                      filename
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "icon button-delete f7-icons",
                                                  },
                                                  [_vm._v("close")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "labelDeleteMobile",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.rm_label"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("input", {
                        staticClass:
                          "item-input hiddenElementAllSize local-file-input",
                        attrs: { type: "file" },
                        on: { change: _vm.executeOCR },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c(
                            "form-write-group-label-input",
                            {
                              attrs: {
                                isMandatory: "",
                                inputLabel: _vm.$t(
                                  "businessDocuments.document_type"
                                ),
                                inputType: "listeSelect",
                                mandatoryErrorIndicator:
                                  _vm.fileTypeSelectedError,
                              },
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.fileTypeSelected,
                                      expression: "fileTypeSelected",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { id: "sel2", readonly: "" },
                                  on: {
                                    change: [
                                      function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.fileTypeSelected = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                      _vm.setSerialize,
                                    ],
                                  },
                                },
                                [
                                  _c("option", { attrs: { value: "" } }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "businessDocuments.slct_doct_type"
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.fileTypeList, function (fileType) {
                                    return _c(
                                      "option",
                                      {
                                        key: fileType.fileTypeValue,
                                        style: fileType.disabled
                                          ? "font-style:italic;"
                                          : "",
                                        attrs: { disabled: fileType.disabled },
                                        domProps: {
                                          value: fileType.fileTypeValue,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(fileType.fileTypeLabel)
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  }),
                                ],
                                2
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              isMandatory: "",
                              inputLabel: _vm.$t(
                                "businessDocuments.request_name"
                              ),
                              placeholderValue: _vm.$t(
                                "businessDocuments.request_name"
                              ),
                            },
                            model: {
                              value: _vm.requestName,
                              callback: function ($$v) {
                                _vm.requestName = $$v
                              },
                              expression: "requestName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              inputLabel: _vm.$t("common.rfrnc"),
                              placeholderValue: _vm.$t("common.rfrnc"),
                            },
                            model: {
                              value: _vm.fileReference,
                              callback: function ($$v) {
                                _vm.fileReference = $$v
                              },
                              expression: "fileReference",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "form-group", attrs: { sm: "6" } },
                        [
                          _c("form-write-group-label-input", {
                            attrs: {
                              inputType: "date",
                              inputLabel: _vm.$t(
                                "businessDocuments.creation_date"
                              ),
                              placeholderValue: _vm.$t("common.slct_date"),
                            },
                            model: {
                              value: _vm.creationDate,
                              callback: function ($$v) {
                                _vm.creationDate = $$v
                              },
                              expression: "creationDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          this.serializeGet.length != 0
            ? _c(
                "div",
                [
                  _c(
                    "form-accordion",
                    {
                      attrs: {
                        title: _vm.$t("businessDocuments.doc_details"),
                        open: _vm.ocrDone,
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _vm._l(_vm.serializeGet, function (value) {
                            return [
                              (value.change === "1" &&
                                _vm.serialize[value.name] !== "") ||
                              (value.change === "0" &&
                                _vm.serialize[value.name])
                                ? [
                                    value.type === "object"
                                      ? _vm._l(
                                          value[0],
                                          function (subvalue, subindex) {
                                            return _c(
                                              "b-col",
                                              {
                                                key: subindex,
                                                staticClass: "form-group",
                                                attrs: { sm: "6" },
                                              },
                                              [
                                                _c(
                                                  "form-write-group-label-input",
                                                  {
                                                    attrs: {
                                                      inputLabel: _vm.$t(
                                                        "businessDocuments.serialize." +
                                                          _vm.fileTypeSelected +
                                                          "." +
                                                          subindex.name
                                                      ),
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.serialize[
                                                          value.name
                                                        ][0][subindex.name],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.serialize[
                                                            value.name
                                                          ][0],
                                                          subindex.name,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "serialize[value.name][0][subindex.name]",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        )
                                      : value.type === "date"
                                      ? _c(
                                          "b-col",
                                          {
                                            staticClass: "form-group",
                                            attrs: { sm: "6" },
                                          },
                                          [
                                            _c("form-write-group-label-input", {
                                              attrs: {
                                                inputType: "date",
                                                inputLabel: _vm.$t(
                                                  "businessDocuments.serialize." +
                                                    _vm.fileTypeSelected +
                                                    "." +
                                                    value.name
                                                ),
                                                placeholderValue:
                                                  _vm.$t("common.slct_date"),
                                              },
                                              model: {
                                                value:
                                                  _vm.serialize[value.name],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.serialize,
                                                    value.name,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "serialize[value.name]",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : value.type === "boolean" &&
                                        value.change === "0"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "form-group col-sm-6",
                                          },
                                          [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "businessDocuments.serialize." +
                                                      _vm.fileTypeSelected +
                                                      "." +
                                                      value.name
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _vm.serialize[value.name] === "0"
                                              ? _c("div", [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon fa fa-check",
                                                    staticStyle: {
                                                      color: "green",
                                                      "font-size": "30px",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "common.status.valid_control_key"
                                                        )
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ])
                                              : _c("div", [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon fa fa-ban",
                                                    staticStyle: {
                                                      color: "red",
                                                      "font-size": "30px",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    "  \n                  "
                                                  ),
                                                  _vm.serialize[value.name] ===
                                                  "1"
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "errors.invalid_control_key"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ])
                                                    : _vm.serialize[
                                                        value.name
                                                      ] === "2"
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "errors.out_of_date"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ])
                                                    : _vm.serialize[
                                                        value.name
                                                      ] === "3"
                                                    ? _c("span", [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "errors.invalid_control_key_out_of_date"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                ]),
                                          ]
                                        )
                                      : _c(
                                          "b-col",
                                          {
                                            staticClass: "form-group",
                                            attrs: { sm: "6" },
                                          },
                                          [
                                            _c("form-write-group-label-input", {
                                              attrs: {
                                                inputLabel: _vm.$t(
                                                  "businessDocuments.serialize." +
                                                    _vm.fileTypeSelected +
                                                    "." +
                                                    value.name
                                                ),
                                              },
                                              model: {
                                                value:
                                                  _vm.serialize[value.name],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.serialize,
                                                    value.name,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "serialize[value.name]",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                  ]
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("hr"),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "form-accordion",
            { attrs: { title: _vm.$t("contacts.recipient_label") } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-dropdown-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.nme"),
                          placeholderValue: _vm.$t("common.recipient_name"),
                          mandatoryErrorIndicator: _vm.recipientNameError,
                          valueKey: "name",
                          subTextKey: "identifier",
                          objectKey: "id",
                        },
                        model: {
                          value: _vm.selectedContact,
                          callback: function ($$v) {
                            _vm.selectedContact = $$v
                          },
                          expression: "selectedContact",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          inputLabel: _vm.$t("common.idtfr"),
                          placeholderValue: _vm.$t("common.recipient_email"),
                          mandatoryErrorIndicator: _vm.recipientEmailError,
                          regexpErrorIndicator: _vm.recipientEmailRegexpError,
                        },
                        model: {
                          value: _vm.recipientEmail,
                          callback: function ($$v) {
                            _vm.recipientEmail = $$v
                          },
                          expression: "recipientEmail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.sharedFoldersConfig ? _c("hr") : _vm._e(),
          _vm._v(" "),
          _vm.sharedFoldersConfig
            ? _c(
                "form-accordion",
                {
                  attrs: { title: _vm.$t("businessDocuments.shared_folders") },
                },
                [
                  _c(
                    "b-form-group",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "b-form-radio",
                                {
                                  staticClass: "creationFormBtnRadio",
                                  attrs: {
                                    name: "radios-sharedFolderType",
                                    value: "1",
                                  },
                                  model: {
                                    value: _vm.sharedFolderType,
                                    callback: function ($$v) {
                                      _vm.sharedFolderType = $$v
                                    },
                                    expression: "sharedFolderType",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("businessDocuments.slct_sdr")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "form-write-group-label-input",
                                {
                                  attrs: {
                                    isMandatory: "",
                                    inputLabel: _vm.$t(
                                      "businessDocuments.slct_sdr"
                                    ),
                                    hiddenLabel: true,
                                    inputType: "listeSelect",
                                    mandatoryErrorIndicator: _vm.folderIdError,
                                  },
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.folderId,
                                          expression: "folderId",
                                        },
                                      ],
                                      staticClass: "form-control",
                                      attrs: { id: "sel2", readonly: "" },
                                      on: {
                                        change: function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.folderId = $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        },
                                      },
                                    },
                                    [
                                      _c("option", { attrs: { value: "" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("creation_forms.slct_a_dr")
                                          )
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.jsonOfSharedFolders,
                                        function (value, index) {
                                          return _c(
                                            "option",
                                            {
                                              key: index,
                                              domProps: { value: index },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(value) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c(
                                "b-form-radio",
                                {
                                  staticClass: "creationFormBtnRadio",
                                  attrs: {
                                    name: "radios-sharedFolderType",
                                    value: "2",
                                  },
                                  model: {
                                    value: _vm.sharedFolderType,
                                    callback: function ($$v) {
                                      _vm.sharedFolderType = $$v
                                    },
                                    expression: "sharedFolderType",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("businessDocuments.add_sdr")
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "form-group", attrs: { sm: "6" } },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  isMandatory: "",
                                  inputLabel: _vm.$t(
                                    "businessDocuments.shared_folder_name"
                                  ),
                                  hiddenLabel: true,
                                  placeholderValue: _vm.$t(
                                    "businessDocuments.shared_folder_name"
                                  ),
                                  mandatoryErrorIndicator: _vm.folderNameError,
                                },
                                model: {
                                  value: _vm.folderName,
                                  callback: function ($$v) {
                                    _vm.folderName = $$v
                                  },
                                  expression: "folderName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c(
            "form-accordion",
            { attrs: { title: _vm.$t("common.add_msg") } },
            [
              _c(
                "b-row",
                [
                  _c("b-col", { staticClass: "form-group" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.formMessage,
                          expression: "formMessage",
                        },
                      ],
                      staticClass: "form-control inputAccordionForm",
                      staticStyle: { "margin-top": "4px" },
                      attrs: { placeholder: _vm.$t("common.general_msg") },
                      domProps: { value: _vm.formMessage },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.formMessage = $event.target.value
                        },
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasReminderRight() ? _c("hr") : _vm._e(),
          _vm._v(" "),
          _vm.hasReminderRight()
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { lg: "6" } },
                    [
                      _c("b-form-group", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.acceptance")) +
                            ":\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c(
                            "b-form-radio",
                            {
                              attrs: { name: "acceptance-radio", value: "1" },
                              model: {
                                value: _vm.letAcceptWithReminder,
                                callback: function ($$v) {
                                  _vm.letAcceptWithReminder = $$v
                                },
                                expression: "letAcceptWithReminder",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "businessDocuments.invoice_accept_reminder_after"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.acceptDaysBeforeReminder,
                                    expression: "acceptDaysBeforeReminder",
                                  },
                                ],
                                staticClass: "pl-0 pr-0 miniFormControl",
                                attrs: {
                                  disabled: _vm.letAcceptWithReminder !== "1",
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.acceptDaysBeforeReminder,
                                },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.acceptDaysBeforeReminder =
                                        $event.target.value
                                    },
                                    function ($event) {
                                      _vm.acceptDaysBeforeReminder =
                                        _vm.inputTypingEvent(
                                          _vm.acceptDaysBeforeReminder,
                                          1,
                                          30,
                                          30
                                        )
                                    },
                                  ],
                                },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "businessDocuments.invoice_day_after_sent"
                                    )
                                  ) +
                                  _vm._s(", ") +
                                  "\n            " +
                                  _vm._s(
                                    _vm.$t("businessDocuments.invoice_then_all")
                                  ) +
                                  "\n            "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.acceptDaysBetweenReminder,
                                    expression: "acceptDaysBetweenReminder",
                                  },
                                ],
                                staticClass: "pl-0 pr-0 miniFormControl",
                                attrs: {
                                  disabled: _vm.letAcceptWithReminder !== "1",
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.acceptDaysBetweenReminder,
                                },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.acceptDaysBetweenReminder =
                                        $event.target.value
                                    },
                                    function ($event) {
                                      _vm.acceptDaysBetweenReminder =
                                        _vm.inputTypingEvent(
                                          _vm.acceptDaysBetweenReminder,
                                          1,
                                          30,
                                          30
                                        )
                                    },
                                  ],
                                },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("businessDocuments.invoice_day_and")
                                  ) +
                                  _vm._s(" ") +
                                  "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "businessDocuments.invoice_stop_after"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.acceptMaxNumberReminder,
                                    expression: "acceptMaxNumberReminder",
                                  },
                                ],
                                staticClass: "pl-0 pr-0 miniFormControl",
                                attrs: {
                                  disabled: _vm.letAcceptWithReminder !== "1",
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.acceptMaxNumberReminder,
                                },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.acceptMaxNumberReminder =
                                        $event.target.value
                                    },
                                    function ($event) {
                                      _vm.acceptMaxNumberReminder =
                                        _vm.inputTypingEvent(
                                          _vm.acceptMaxNumberReminder,
                                          0,
                                          10,
                                          0
                                        )
                                    },
                                  ],
                                },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("businessDocuments.invoice_reminder")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-radio",
                            {
                              attrs: { name: "acceptance-radio", value: "0" },
                              model: {
                                value: _vm.letAcceptWithReminder,
                                callback: function ($$v) {
                                  _vm.letAcceptWithReminder = $$v
                                },
                                expression: "letAcceptWithReminder",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "businessDocuments.invoice_accept_no_reminder"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { lg: "6" } },
                    [
                      _c("b-form-group", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.payment")) +
                            ":\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        [
                          _c(
                            "b-form-radio",
                            {
                              attrs: { name: "payment-radio", value: "1" },
                              model: {
                                value: _vm.letPayWithReminder,
                                callback: function ($$v) {
                                  _vm.letPayWithReminder = $$v
                                },
                                expression: "letPayWithReminder",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "businessDocuments.invoice_payment_reminder_after"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.payDaysBeforeReminder,
                                    expression: "payDaysBeforeReminder",
                                  },
                                ],
                                staticClass: "pl-0 pr-0 miniFormControl",
                                attrs: {
                                  disabled: _vm.letPayWithReminder !== "1",
                                  type: "text",
                                },
                                domProps: { value: _vm.payDaysBeforeReminder },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.payDaysBeforeReminder =
                                        $event.target.value
                                    },
                                    function ($event) {
                                      _vm.payDaysBeforeReminder =
                                        _vm.inputTypingEvent(
                                          _vm.payDaysBeforeReminder,
                                          1,
                                          30,
                                          30
                                        )
                                    },
                                  ],
                                },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "businessDocuments.invoice_day_after_sent"
                                    )
                                  ) +
                                  _vm._s(", ") +
                                  "\n            " +
                                  _vm._s(
                                    _vm.$t("businessDocuments.invoice_then_all")
                                  ) +
                                  "\n            "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.payDaysBetweenReminder,
                                    expression: "payDaysBetweenReminder",
                                  },
                                ],
                                staticClass: "pl-0 pr-0 miniFormControl",
                                attrs: {
                                  disabled: _vm.letPayWithReminder !== "1",
                                  type: "text",
                                },
                                domProps: { value: _vm.payDaysBetweenReminder },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.payDaysBetweenReminder =
                                        $event.target.value
                                    },
                                    function ($event) {
                                      _vm.payDaysBetweenReminder =
                                        _vm.inputTypingEvent(
                                          _vm.payDaysBetweenReminder,
                                          1,
                                          30,
                                          30
                                        )
                                    },
                                  ],
                                },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("businessDocuments.invoice_day_and")
                                  ) +
                                  _vm._s(" ") +
                                  _vm._s(
                                    _vm.$t(
                                      "businessDocuments.invoice_stop_after"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.payMaxNumberReminder,
                                    expression: "payMaxNumberReminder",
                                  },
                                ],
                                staticClass: "pl-0 pr-0 miniFormControl",
                                attrs: {
                                  disabled: _vm.letPayWithReminder !== "1",
                                  type: "text",
                                },
                                domProps: { value: _vm.payMaxNumberReminder },
                                on: {
                                  input: [
                                    function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.payMaxNumberReminder =
                                        $event.target.value
                                    },
                                    function ($event) {
                                      _vm.payMaxNumberReminder =
                                        _vm.inputTypingEvent(
                                          _vm.payMaxNumberReminder,
                                          0,
                                          10,
                                          0
                                        )
                                    },
                                  ],
                                },
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("businessDocuments.invoice_reminder")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-radio",
                            {
                              attrs: { name: "payment-radio", value: "0" },
                              model: {
                                value: _vm.letPayWithReminder,
                                callback: function ($$v) {
                                  _vm.letPayWithReminder = $$v
                                },
                                expression: "letPayWithReminder",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "businessDocuments.invoice_payment_no_reminder"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footerButtons" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-start" },
            [
              _c(
                "b-col",
                {
                  staticClass: "form-group",
                  attrs: { md: "3", "offset-md": "8" },
                },
                [
                  _c(
                    "f7-button",
                    {
                      staticClass: "button-action milkyBlockBlack",
                      on: { click: _vm.sendBusinessDocument },
                    },
                    [
                      _c("f7-icon", { attrs: { fa: "paper-plane" } }),
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "businessDocuments.form_document_send_button"
                            )
                          ) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }